export function getUniqueObjects<T>(
  items: T[],
  propPathId: string[],
  propPathDescription: string[],
  filterTitle: string
): { id: string; title: string }[] {
  const SENSE_TITLE = `Sense ${filterTitle.toLocaleLowerCase()}`;
  const map = new Map<string, { id: string; title: string }>();
  let hasSenseItem = false;

  for (const item of items) {
    const id = propPathId.reduce((acc, key) => acc?.[key], item);
    const title = propPathDescription.reduce((acc, key) => acc?.[key], item);

    const isValidId = typeof id === "string" && id.trim() !== "";

    //Tret el trim del title pels casos de migració on arriben camps buits
    const isValidTitle = typeof title === "string";

    if (isValidId && isValidTitle) {
      if (!map.has(id)) {
        map.set(id, { id, title });
      }
    } else {
      hasSenseItem = true;
    }
  }

  const result = Array.from(map.values()).sort((a, b) =>
    a.title.localeCompare(b.title, "ca", { sensitivity: "base" })
  );

  if (hasSenseItem) {
    result.push({ id: "", title: SENSE_TITLE });
  }

  return result;
}